exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "contact-expert-success .alert-with-icon p{font-size:22px;line-height:25px}contact-expert-success .alert-with-icon i{padding:8px;border:2px solid #000;-webkit-border-radius:50px;-moz-border-radius:50px;border-radius:50px}", "", {"version":3,"sources":["/var/lib/ci/xml-data/build-dir/TEL-EFS-CBP/frontend/client/src/components/contact-expert-success/contact-expert-success.less"],"names":[],"mappings":"AAAA,0CAGM,eACA,gBAAA,CAJN,0CAOM,YACA,sBACA,2BACA,wBACA,kBAAA,CAAA","file":"contact-expert-success.less","sourcesContent":["contact-expert-success {\n  .alert-with-icon {\n    p {\n      font-size: 22px;\n      line-height: 25px;\n    }\n    i {\n      padding: 8px;\n      border: 2px solid #000;\n      -webkit-border-radius: 50px;\n      -moz-border-radius: 50px;\n      border-radius: 50px;\n    }\n  }\n}\n\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader?sourceMap!../~/absolute-path-less-loader?sourceMap!./src/components/contact-expert-success/contact-expert-success.less
// module id = 590
// module chunks = 0